const GUEST_PLATFORM_FEE_LABEL = "Guest platform fee";

// Gated on the flag AND currency, never the flag alone: this app ships one global bundle to every
// region, and the AU deployment also serves NZD venues.
export const getProcessingFeeRowTitle = (currency: string | undefined, guestPlatformFeeEnabled?: boolean) => {
    const normalisedCurrency = currency?.toLocaleLowerCase();

    if (guestPlatformFeeEnabled && normalisedCurrency === "aud") {
        return GUEST_PLATFORM_FEE_LABEL;
    }

    return normalisedCurrency === "gbp" ? "Service fee" : "Processing fee";
};
